import { render, staticRenderFns } from "./TargetGroupPrograms.vue?vue&type=template&id=51850288&scoped=true&"
import script from "./TargetGroupPrograms.vue?vue&type=script&lang=js&"
export * from "./TargetGroupPrograms.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupPrograms.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TargetGroupPrograms.vue?vue&type=style&index=1&id=51850288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51850288",
  null
  
)

export default component.exports